<template>
  <aside class="admin-sidebar" :class="{ 'admin-sidebar-mobile-open': isMobileOpen }">
    <!-- Mobile Close Button -->
    <button class="admin-sidebar-close-btn" @click="$emit('close-mobile')" aria-label="Close menu">
      <i class="bi bi-x-lg"></i>
    </button>
    <nav class="admin-sidebar-nav">
      <button 
        class="admin-sidebar-item" 
        :class="{ active: activeTab === 'dashboard' }"
        @click="$emit('tab-change', 'dashboard')"
      >
        <i class="fas fa-chart-line"></i>
        <span>Dashboard</span>
      </button>
      <button 
        class="admin-sidebar-item" 
        :class="{ active: activeTab === 'clients' }"
        @click="$emit('tab-change', 'clients')"
      >
        <i class="fas fa-users"></i>
        <span>My Clients</span>
      </button>
      
      <!-- Settings Menu with Submenu -->
      <div class="admin-sidebar-settings">
        <button
          class="admin-sidebar-item admin-sidebar-settings-toggle"
          :class="{ active: isSettingsTabActive }"
          @click="toggleSettings"
        >
          <i class="fas fa-cog"></i>
          <span>Settings</span>
          <i class="fas fa-chevron-down admin-sidebar-chevron" :class="{ 'admin-sidebar-chevron-open': isSettingsOpen }"></i>
        </button>
        <div class="admin-sidebar-submenu" :class="{ 'admin-sidebar-submenu-open': isSettingsOpen }">
          <button 
            class="admin-sidebar-submenu-item" 
            :class="{ active: activeTab === 'settings-profile' }"
            @click="$emit('tab-change', 'settings-profile')"
          >
            <i class="fas fa-user-edit"></i>
            <span>Profile Update</span>
          </button>
        </div>
      </div>
    </nav>
    <ClientManagerProfileView v-if="managerUser" :managerUser="managerUser" @logout="$emit('logout')" />
  </aside>
</template>

<script>
import '../styles/ClientManagerSideMenu.css';
import ClientManagerProfileView from './ClientManagerProfileView.vue';

export default {
  name: 'ClientManagerSideMenu',
  components: {
    ClientManagerProfileView
  },
  props: {
    activeTab: {
      type: String,
      required: true
    },
    managerUser: {
      type: Object,
      required: false,
      default: null
    },
    isMobileOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['tab-change', 'logout', 'close-mobile'],
  data() {
    return {
      isSettingsOpen: false,
    }
  },
  computed: {
    /** True only when one of the Settings sub-tabs is the current view.
     *  Drives the "active" highlight on the parent Settings row so it
     *  doesn't stay lit just because the submenu happens to be expanded. */
    isSettingsTabActive() {
      return this.activeTab === 'settings' || this.activeTab === 'settings-profile';
    },
  },
  watch: {
    activeTab: {
      immediate: true,
      handler(newTab) {
        // Expand the submenu when a settings tab becomes active; collapse it
        // again when the user navigates to a non-settings tab. This avoids
        // the previous bug where the Settings row stayed highlighted (via
        // `isSettingsOpen`) even after switching to My Clients or Dashboard.
        if (newTab === 'settings' || newTab === 'settings-profile') {
          this.isSettingsOpen = true;
        } else {
          this.isSettingsOpen = false;
        }
      },
    },
  },
  methods: {
    toggleSettings() {
      this.isSettingsOpen = !this.isSettingsOpen;
      if (this.isSettingsOpen && !this.isSettingsTabActive) {
        this.$emit('tab-change', 'settings-profile');
      }
    },
  },
}
</script>
